// Define the interface for the option model
export interface Option {
  viewValue: string;
  value: string;
}

// Define the array of options
export const GeometryTypes: Option[] = [
  { viewValue: 'Polygon', value: 'polygon' },
  { viewValue: 'Line', value: 'line' },
  { viewValue: 'Point', value: 'point' }
];
